
import {View} from 'backbone';
import template from 'common-views/test-email-server.ejs';
import constants from 'Constants.js';
import $ from 'jquery';
import util from 'util/Util.js';

class TestEmailServerModalView extends View {
    initialize(opts){
        super.initialize(opts);
        if (!this.model.get('subtitle')) {
            this.model.set('subtitle',  'Confirmation Dialog');
        }
        $('body').append(this.$el);
    }

    processInputs(e){
        const propName=e.currentTarget.name;
        const propValue=e.currentTarget.value;
        this.model.set(propName,propValue,{silent:true});
        console.log("This is the actual model",this.model);
        if(this.model.get('email') && this.model.get('subject') && util.validateEmail(this.model.get('email'))){
            $('.btn-select-item').prop('disabled', false).removeClass('ui-button-disabled').removeClass('ui-state-disabled');
        }
        else{
            $('.btn-select-item').prop('disabled', true).addClass('ui-button-disabled').addClass('ui-state-disabled');
        }
    }



    render(){
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            this.delegateEvents();

            $( constants.DIALOG_ID ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 250,
                width: 350,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Ok',
                        'class':'btn-select-item',
                        disabled:true,
                        click: () => {
                            resolve({email:this.model.get('email'),subject:this.model.get('subject')});
                            this.closeModal();
                        }
                    },
                    {
                        'text': 'Cancel',
                        click: () => {
                            resolve({});
                            this.closeModal();
                        }
                    }
                ],
                open: () => {
                    $(constants.DIALOG_ID).css('overflow','hidden');
                    this.bindEvents();
                },
                close: () => {
                    $(constants.DIALOG_ID).css('overflow','scroll');
                    this.unbindEvents();
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        });
    }
    bindEvents(){
        $(constants.DIALOG_ID).find('input[type=text]').change(e => this.processInputs(e));
    }
    unbindEvents(){
        $(constants.DIALOG_ID).find('input[type=text]').unbind();
    }

    closeModal(){
        $( constants.DIALOG_ID ).dialog("destroy").remove();
    }
}

export default TestEmailServerModalView;